import { B2Button } from "@hdb/biome-2";
import React from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router";
import "./error.scss";

const ForbiddenComponent: React.FC = () => {
  const navigate = useNavigate();

  function goBack() {
    if (window?.history?.length >= 2) {
      navigate(-2);
      return;
    } else if (window?.history?.length > 1) {
      navigate(-1);
      return;
    }

    navigate("/login");
  }

  return (
    <>
      <Helmet>
        <title>403 Forbidden | SLP</title>
      </Helmet>
      <div className="forbidden-container">
        <h1 className="forbidden-text">403 Forbidden</h1>
        <p className="forbidden-description">
          Sorry, you don't have permission to access this page.
        </p>

        <B2Button variant="primary" onClick={goBack}>
          Go Back
        </B2Button>
      </div>
    </>
  );
};

export default ForbiddenComponent;
